import { AgencyActionTypes } from '../constants/ApiConstants';
// import { extractDataFromObject } from './../../../../src/actions/utilAction';

const initialState = {
  loading: false,
  loadingField: false,
  master_data: [],
  agencyList: [],
  agencyData: {},
};


export default (state = initialState, { type, payload }) => {

  switch (type) {
  case AgencyActionTypes.get_master_data.REQUEST:  
  case AgencyActionTypes.post_agency_data.REQUEST:
  case AgencyActionTypes.get_Agency.REQUEST:   
  case AgencyActionTypes.delete_agency_data.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case AgencyActionTypes.get_Agency_byId.REQUEST:
    return {
      ...state,
      agencyData: {},
      loading: true,
    };
  case AgencyActionTypes.get_master_data.SUCCESS:
    return {
      ...state,
      master_data: payload,
      loading: false,
    };
  case AgencyActionTypes.get_Agency.SUCCESS:
    return {
      ...state,
      agencyList: payload,
      loading: false,
    };
  case AgencyActionTypes.get_Agency_byId.SUCCESS:
    return {
      ...state,
      agencyData: payload,
      loading: false,
    };
  case AgencyActionTypes.post_agency_data.SUCCESS:
    return {
      ...state,
      agencyData: payload,
      loading: false,
    };
  case AgencyActionTypes.delete_agency_data.SUCCESS:
    return {
      ...state,
      agencyData: payload,
      loading: false,
    };
  case AgencyActionTypes.check_agency_name.REQUEST:
    return {
      ...state,
      loadingField: true,
      isExist: null,
    };
  case AgencyActionTypes.check_agency_name.SUCCESS:
    return {
      ...state,
      loadingField: false,
      isExist: payload,
    };
  default:
    return state;
  }

};



// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageAgency/reducers/AgencyReducer.js